






























































































import { Component, Vue } from 'vue-property-decorator';
import {dispatchSubmitResetCredsByToken, dispatchSubmitResetPassword} from '@/store/main/actions';
// @ts-ignore
import backgroundImg from '@/assets/images/login_background_new.jpeg';
// @ts-ignore
import backgroundImgX2 from '@/assets/images/login_background_newx2.jpeg';
import { api } from '@/api';

@Component({})
export default class ResetCredentials extends Vue {
  public resetStep = 0;
  public blockBtn = false;
  public email = '';
  public password = '';
  public backgroundImage = backgroundImg;
  public backgroundImageX2 = backgroundImgX2;

  public mounted() {
    this.checkToken();
  }

  public async checkToken() {
    const token = (this.$router.currentRoute.params.resetToken as string);
    try {
      const response = await api.checkResetCredsToken(
        {token},
      );
      this.resetStep = 1;
    } catch (e) {
      this.resetStep = 3;
      setTimeout(() => { this.$router.push('/login'); }, 3000);
    }
  }

  public async handleSubmitReset() {
    if (!this.email || !this.password) {
      // @ts-ignore
      this.showToast(this, this.$t('Please, fill both fields'), 'error');
      return null;
    }
    this.blockBtn = true;
    const response = await dispatchSubmitResetCredsByToken(
      this.$store,
      {
        email: this.email,
        password: this.password,
        token: this.$router.currentRoute.params.resetToken,
      },
    );
    if (response === 400) {
      // @ts-ignore
      this.showToast(this, this.$t('Email is already in use'), 'error');
    } else if (response !== 200) {
      // @ts-ignore
      this.showToast(this, this.$t('Error'), 'error');
    }
    this.blockBtn = false;
  }
}

